export class PropertyCategory {
  id!: number;
  name!: string;
  description!: string;
}
